import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  MonitoringEnforcementTPProtocolsGetTpProgressFilterRequest,
  MonitoringFilterProtocolRequest,
  MonitoringFilterProtocolResponse,
} from '~/swagger/data-contracts';
import {
  QUERY_KEYS_CUSTOM_TAG_FILTER,
  QUERY_KEYS_SHIP_FROM_FILTER,
  QUERY_KEYS_TEST_PURCHASE_PROGRESS_FILTER,
} from '~/apis/@constants';
import { monitoringEnforcementTpApi, monitoringFilterApi } from '..';

export const useGetAllCustomTagsQuery = <TData>(
  request: MonitoringFilterProtocolRequest,
  options?: UseQueryOptions<MonitoringFilterProtocolResponse, null, TData>
) => {
  return useQuery({
    queryKey: [...QUERY_KEYS_CUSTOM_TAG_FILTER, request],
    queryFn: async () => {
      const { data } = await monitoringFilterApi.filterGetAllCustomTagsCreate(request);
      return data;
    },
    ...options,
  });
};

export const useGetAllShipFromQuery = <TData>(
  request: MonitoringFilterProtocolRequest,
  options?: UseQueryOptions<MonitoringFilterProtocolResponse, null, TData>
) => {
  return useQuery({
    queryKey: [...QUERY_KEYS_SHIP_FROM_FILTER, request],
    queryFn: async () => {
      const { data } = await monitoringFilterApi.filterGetAllShipFromCreate(request);
      return data;
    },
    ...options,
  });
};

export const useGetAllTrademarkedLogosQuery = <TData>(
  request: MonitoringFilterProtocolRequest,
  options?: UseQueryOptions<MonitoringFilterProtocolResponse, null, TData>
) => {
  return useQuery({
    queryKey: ['monitoring-filter-trademarked-logos', request],
    queryFn: async () => {
      const { data } = await monitoringFilterApi.filterGetAllTrademarkedLogosCreate(request);
      return data;
    },
    ...options,
  });
};

export const useGetAllListingCommentsQuery = <TData>(
  request: MonitoringFilterProtocolRequest,
  options?: UseQueryOptions<MonitoringFilterProtocolResponse, null, TData>
) => {
  return useQuery({
    queryKey: ['monitoring-filter-listing-comments', request],
    queryFn: async () => {
      const { data } = await monitoringFilterApi.filterGetAllCommentUserTypesCreate(request);
      return data;
    },
    ...options,
  });
};

export const useTestPurchaseProgressFilterQuery = <TData>(
  request: MonitoringEnforcementTPProtocolsGetTpProgressFilterRequest,
  options?: UseQueryOptions<MonitoringFilterProtocolResponse, null, TData>
) => {
  return useQuery({
    queryKey: [...QUERY_KEYS_TEST_PURCHASE_PROGRESS_FILTER, request],
    queryFn: async () => {
      const { data } = await monitoringEnforcementTpApi.enforcementTpProgressFilterCreate(request);
      return data;
    },
    ...options,
  });
};
